import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { SITE, NAV_LINKS, CATEGORIES } from "../data/products";

const Footer = () => (
  <footer data-testid="site-footer" className="grain relative bg-night text-white">
    <div className="relative z-10 mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            Bio-scientific feed additives — palatants, sweeteners, toxin management and
            nutritional specialities for modern animal nutrition.
          </p>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-emerald-300/80">Explore</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="link-underline text-sm text-white/70 hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-emerald-300/80">Product Range</h3>
          <ul className="mt-5 space-y-3">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to="/products" data-testid={`footer-link-category-${c.slug}`} className="link-underline text-sm text-white/70 hover:text-white">
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-emerald-300/80">Contact</h3>
          <ul className="mt-5 space-y-4">
            <li>
              <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-3 text-sm text-white/70 hover:text-white">
                <Phone className="h-4 w-4 text-teal-400" /> {SITE.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-sm text-white/70 hover:text-white">
                <Mail className="h-4 w-4 text-teal-400" /> {SITE.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-4 border-t border-emerald-100/10 pt-8 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
        <p data-testid="footer-group-company">
          A division / affiliate of <span className="font-semibold text-white/80">{SITE.groupCompany}</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
